<template>
    <div class="photo-section">
        <v-icon v-if="this.alreadyUploadedFiles.length > 0" class="all-download-icon" color="blue" large @click="downloadZip()">mdi-download</v-icon>
        <div class="title"><h4 v-if="!editMode"> {{ title }} </h4></div>
        <div v-if="editMode || this.filePreview.length > 0" >
            <v-progress-linear
                v-if="filesToUploadProgress"
                class="progress"
                color="#0047AB"
                buffer-value="0"
                :value="filesToUploadProgress"
                stream
            ></v-progress-linear>
            <div class = "form-group-fields">
                <v-file-input
                    v-if="editMode"
                    v-model="filesToUploadTemp"
                    :rules="editMode ? rules: []"
                    accept="application/pdf, text/csv, .csv, text/plain, application/msword, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/zip, .zip"
                    :placeholder="this.label"
                    prepend-icon="mdi-file-multiple"
                    :clearable="clearable"
                    :label="this.label"
                    class="field"
                    multiple
                    counter
                    :disabled="readOnly"
                ></v-file-input>
            </div>
            <div class="file-preview-wrapper">
                <v-card
                    v-for="(file, index) in this.filePreview"
                    :key="index"
                    class="file-card"
                >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                                <v-icon v-if="file.url" class="download-icon" color="blue" large @click="downloadFile(file.url)">mdi-download</v-icon>
                                <v-img
                                    :src="getIconImage(file.type)"
                                    max-width="100px"
                                    max-height="100px"
                                    class="the-file"
                                />
                                <div
                                    v-if="!file.url"
                                    class="file-delete"
                                    @click="removeFileFromUpload(file)"
                                >Διαγραφή</div>
                            </div>
                        </template>
                        {{ file.name }}
                    </v-tooltip>
                </v-card>
                <div v-if="this.filesToUploadProgress > 0" class="loading-overlay">
                    <div class="loader" />Περιμένετε μέχρι τα αρχεία να ανέβουν..
                </div>
            </div>
            <v-progress-linear
                v-if="filesToUploadProgress"
                class="progress"
                color="#0047AB"
                buffer-value="0"
                :value="filesToUploadProgress"
                stream
            ></v-progress-linear>
        </div>
        <div v-else class="no-files">
            Δεν υπάρχουν αρχεία
        </div>
    </div>
</template>

<script>
    import uploadService from '@/services/upload'
    import JSZip from 'jszip'
    import axios from 'axios'
    import { saveAs } from 'file-saver'
    const HETZNER_API_STORAGE_URL = process.env.VUE_APP_HETZNER_API_STORAGE_URL
    const path = require('path')
    const docIcon = require('@/assets/doc.png')
    const pdfIcon = require('@/assets/pdf.png')
    const excelIcon = require('@/assets/excel.png')
    const zipIcon = require('@/assets/zip.png')
    export default {
        props: {
            alreadyUploadedFiles: {
                type: Array,
                required: true
            },
            readOnly: {
                type: Boolean,
                required: true
            },
            editMode: {
                type: Boolean,
                required: true
            },
            clearable: {
                type: Boolean,
                required: true
            },
            folderPath: {
                type: String,
                required: false
            },
            label: {
                type: String,
                required: false
            },
            title: {
                type: String,
                required: false,
                default: () => { return '' }
            },
            zipName: {
                type: String,
                required: false,
                default: () => { return 'download' }
            }
        },
        watch: {
            filesToUpload: {
                handler(val, oldVal) {
                    this.initFilePreview()
                },
                deep: true
            },
            filesToUploadTemp: {
                handler(val, oldVal) {
                    this.filesToUpload = [ ...this.filesToUpload.concat(this.filesToUploadTemp) ]
                },
                deep: true
            },
            editMode: {
                handler(val, oldVal) {
                    this.initFilePreview()
                }
            },
            alreadyUploadedFiles: {
                handler(val, oldVal) {
                    this.initFilePreview()
                },
                deep: true
            }
        },
        data() {
            return {
                filesToUpload: [],
                filesToUploadTemp: [],
                filePreview: [],
                filesToUploadProgress: 0,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ]
            }
        },
        methods: {
            async downloadZip() {
                const zip = new JSZip()
                const folder = zip.folder('files')
                const downloadPromises = this.alreadyUploadedFiles.map(async(url) => {
                    let fileUrl
                    if (this.isUrl(url)) {
                        fileUrl = url
                    } else {
                        fileUrl = HETZNER_API_STORAGE_URL + '/' + url
                    }
                    return axios
                        .get(fileUrl, {
                            headers: {
                                'Cache-Control': 'no-cache',
                                'Pragma': 'no-cache'
                            },
                            responseType: 'blob'
                        })
                        .then(response => {
                            let fileName = url.substring(url.lastIndexOf('/')).substring(1)
                            folder.file(fileName, response.data)
                        })
                        .catch(error => {
                            console.error(`Error fetching ${url}:`, error)
                        })
                })

                try {
                    await Promise.all(downloadPromises)
                    const content = await zip.generateAsync({ type: 'blob' })
                    saveAs(content, this.zipName + '.zip')
                } catch (error) {
                    console.error('Error generating ZIP:', error)
                }
            },
            isUrl(str) {
                try {
                    const url = new URL(str)
                    return url.protocol === 'http:' || url.protocol === 'https:'
                } catch {
                    return false
                }
            },
            downloadFile(url) {
                var name = path.basename(url)
                fetch(url)
                    .then(response => response.blob())
                    .then(blob => {
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = name
                        link.click()
                    })
                    .catch(console.error)
            },
            clearfilesToUpload() {
                this.filesToUpload = []
            },
            getIconImage(type) {
                switch (type) {
                case '.doc': return docIcon
                case '.txt': return docIcon
                case '.text': return docIcon
                case '.xls': return excelIcon
                case '.xlsx': return excelIcon
                case '.csv': return excelIcon
                case '.pdf': return pdfIcon
                case '.zip': return zipIcon
                }
            },
            async uploadSelectedFiles() {
                if (this.filesToUpload.length === 0) {
                    return []
                }
                let uploadedFiles = []
                this.filesToUploadProgress = 0
                const perFileProgress = 100 / this.filesToUpload.length
                for (let file of this.filesToUpload) {
                    let formData = new FormData()
                    formData.append('file', file)
                    try {
                        this.filesToUploadProgress += perFileProgress
                        const response = await uploadService.uploadFile(this.folderPath, formData)
                        uploadedFiles.push(response.data.content)
                    } catch (e) {
                        this.onFileUploadError(e)
                    }
                }
                this.filesToUpload = []
                this.filesToUploadProgress = 0
                return uploadedFiles
            },
            onFileUploadError(e) {
                this.filesToUploadProgress = 0
                if (e.response.data.code === 'WRONG_FILE_TYPE') {
                    throw Error('Λάθος τύπος αρχείου για ανέβασμα')
                } else {
                    throw Error(e.response.data.message)
                }
            },
            initFilePreview() {
                this.filePreview = []
                this.alreadyUploadedFiles.forEach(fileUrl =>
                    this.filePreview.push({ url: HETZNER_API_STORAGE_URL + '/' + fileUrl, type: path.extname(fileUrl), name: path.basename(fileUrl) })
                )
                this.filesToUpload.forEach(file =>
                    this.filePreview.push({ file: file, type: path.extname(file.name), name: file.name })
                )
                this.filePreview = [...this.filePreview]
            },
            removeFileFromUpload(photo) {
                const index1 = this.filePreview.indexOf(photo)
                this.filePreview.splice(index1, 1)
                const index2 = this.filesToUpload.indexOf(photo.file)
                this.filesToUpload.splice(index2, 1)
            },
            setPhotoToDisplay(photoIndex) {
                this.carouselfile = photoIndex
                this.photoDialog = true
            }
        }
    }
</script>

<style scoped>
.no-files {
    color: var(--cards-and-tables-text-color) !important;
    font-style: italic;
}
.all-download-icon {
    position: absolute;
    right: 2rem;
    z-index: 1;
}
.loading-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    width: 100%;
}
.loader {
    margin-right: 0.5rem;
    min-width: 3rem;
    min-height: 3rem;
    transform: translateZ(0);
    box-sizing: border-box;
    width: 3rem;
    height: 3rem;
    border: 0.5em solid rgba(255, 255, 255, 0.3);
    border-top: 0.5rem solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.progress {
    width: 95%;
    margin: 0 auto;
}
.field.status {
    min-width: 300px;
    max-width: 50%;
}

.file-preview-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
}

.photo-section {
    border: solid 1px gray;
    padding: 1rem;
    border-radius: 5px;
    width: 100%;
}

.carousel {
    display: flex !important;
    justify-content: center !important;
}

.file-container {
    width: 400px !important;
    height: 250px;
    overflow: hidden;
}

.file-container, .file-carousel {
    width: 100%;
    height: auto;
    display: block;
}

.file-card {
    border-radius: 10px;
    cursor: pointer;
    margin: 0.2rem;
    display: flex;
    flex-direction: column;
}

.the-file {
    margin: 0.3rem;
}

.file-delete {
    background-color: red;
    color: white;
    display: flex;
    justify-content: center;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.spacer {
    display: none;
}

.v-card__actions, .v-card__title {
    display: flex;
    justify-content: center;
}

.download-icon {
    position: absolute;
    right: 0;
    z-index: 1;
}

@media only screen and (max-width: 436px) {
  .file-preview-wrapper {
        justify-content: center;
    }
}
</style>
